import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  loginRequest: ['phone', 'password'],
  loginSuccess: ['token'],
  logoutRequest: null,
  logoutSuccess: null,
  rememberPasswordRequest: ['phone'],
  rememberPasswordSuccess: null,
  autoLogin: null,
  authFailure: ['error'],
});

export const AuthTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  token: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to login
export const request = (state) =>
  state.merge({fetching: true, error: null});

// we've successfully logged in
export const success = (state, {token}) =>
  state.merge({fetching: false, error: null, token});

// we've had a problem logging in
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});

// we've logged out
export const logoutSuccess = state => INITIAL_STATE;


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN_REQUEST]: request,
  [Types.LOGIN_SUCCESS]: success,
  [Types.LOGOUT_REQUEST]: request,
  [Types.LOGOUT_SUCCESS]: logoutSuccess,
  [Types.REMEMBER_PASSWORD_REQUEST]: request,
  [Types.REMEMBER_PASSWORD_SUCCESS]: logoutSuccess,
  [Types.AUTO_LOGIN]: request,
  [Types.AUTH_FAILURE]: failure,
});

